import { render } from "./WarningCircle.vue?vue&type=template&id=2780bb6e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WarningCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2780bb6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2780bb6e', __exports__)) {
    api.reload('2780bb6e', __exports__)
  }
  
  module.hot.accept("./WarningCircle.vue?vue&type=template&id=2780bb6e", () => {
    api.rerender('2780bb6e', render)
  })

}


export default __exports__